const sk = {
  code: 'sk',
  short: 'SK',
  label: 'Slovenčina',
  native: 'Slovenčina',
  hero: {
    badge: 'Upratovacie služby • Bratislava',
    title: 'Čistý priestor. Čistá hlava.',
    lead: 'Spoľahlivé domáce aj kancelárske upratovanie s jasnými cenami a jednoduchou rezerváciou.',
    cta: 'Objednať',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Domov',
    services: 'Služby',
    contact: 'Kontakt',
    book: 'Objednať',
    whatsapp: 'WhatsApp',
    language: 'Jazyk'
  },
  home: {
    licensed: 'Licencované • Poistené • Prostriedky v cene',
    firstCleanDiscountBadge: '10 %',
    firstCleanDiscount: 'Zľava na prvé upratovanie',
    servicesTitle: 'Naše služby',
    seeDetails: 'Zobraziť detaily →',
    whyTitle: 'Prečo Sparklean?',
    reasons: [
      'Spoľahlivý a overený tím špecialistov',
      'Profesionáli s referenciami a preukázanou praxou',
      'Flexibilné termíny vrátane večerov',
      'Fixné ceny, žiadne skryté poplatky'
    ],
    areaTitle: 'Pôsobenie',
    areaCopy: 'Bratislava a okolie.',
    quote: 'Získať cenovú ponuku'
  },
  optional: 'voliteľné',
  servicesPage: {
    title: 'Služby',
    subtitle: 'Kliknite na kartu a otvorí sa stránka s kontrolnými zoznamami, galériou a cenovými poznámkami.'
  },
  notFound: {
    message: 'Stránka neexistuje.',
    back: 'Späť domov'
  },
  serviceDetail: {
    notFound: 'Služba sa nenašla',
    back: 'Späť na služby',
    bookThis: 'Objednať službu',
    allServices: 'Všetky služby'
  },
  contact: {
    title: 'Kontakt',
    hours: 'Odpovedáme Po–So 8:00–20:00.',
    emailLabel: 'Email',
    phoneLabel: 'Telefón',
    whatsappAvailable: 'Dostupní aj na WhatsApp',
    whatsapp: 'Napísať na WhatsApp',
    email: 'Poslať email',
    office: 'Kancelária',
    address: 'Karpatské námestie 10A, Bratislava, Slovensko'
  },
  booking: {
    title: 'Rezervácia',
    subtitle: 'Napíšte nám o vašom priestore a termíne. Potvrdíme emailom alebo cez WhatsApp.',
    fullName: 'Celé meno',
    fullNamePlaceholder: 'Jana Nováková',
    serviceField: 'Služba',
    dateField: 'Preferovaný dátum',
    datePlaceholder: 'DD-MM-RRRR',
    timeField: 'Preferovaný čas',
    nameField: 'Meno',
    emailField: 'Email',
    phoneField: 'Telefón',
    phonePlaceholder: '+421 900 000 000',
    addressField: 'Adresa',
    addressPlaceholder: 'Ulica, číslo, mestská časť',
    notesField: 'Poznámky',
    notesPlaceholder: 'Domáce zvieratá, parkovanie, kód brány a pod.',
    submit: 'Odoslať dopyt',
    chooseService: 'Vybrať službu',
    pick: 'Vybrať',
    successTitle: 'Dopyt odoslaný ✅',
    successLine: 'Ďakujeme! Vaše číslo:',
    successNote: 'Čoskoro potvrdíme emailom alebo na WhatsAppe.',
    calendarMonth: 'long',
    pickerDescription: 'Vyberte typ upratovania, ktorý potrebujete.',
    pickerTip: 'Tip: neskôr ho môžete zmeniť.',
    whatsappAlt: 'alebo nám napíšte na WhatsApp',
    privacy: 'Vaše údaje chránime. Odoslaním súhlasíte s kontaktovaním ohľadom tejto žiadosti.',
    error: 'Niečo sa pokazilo. Skúste znova.',
    errorTitle: 'Žiadosť nebola odoslaná',
    errorMessage: 'Žiadosť sa nepodarilo odoslať. Skúste znova alebo nás kontaktujte priamo.',
    errorWhatsapp: 'Otvoriť WhatsApp chat',
    errorEmail: 'Napísať email',
    required: 'Toto pole je povinné',
    emailError: 'Zadajte platný email',
    phoneError: 'Použite čísla, +, medzeru alebo pomlčku',
    minChars: 'Minimálne 10 znakov',
    addressHint: 'Zadajte ulicu a číslo',
    pickerTitle: 'Vyberte službu',
    calendarTitle: 'Vyberte dátum'
  },
  footer: {
    tagline: 'Profesionálne upratovacie služby v Bratislave a okolí.',
    rights: 'Všetky práva vyhradené.',
    getInTouch: 'Kontakt',
    chat: 'Napísať na WhatsApp'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Pravidelné upratovanie',
      short: 'Udržujte domov čistý a svieži na dennej alebo týždennej báze.',
      intro: 'Pravidelné upratovanie pomáha udržať poriadok a čistotu.',
      description: [
        'Zabezpečíme dôkladné vysávanie a umytie všetkých dostupných plôch, opatrné utretie prachu a vyčistenie kuchynských aj kúpeľňových prvkov — dom ostane svieži, čistý a pohodlný.',
        'Odporúčaná frekvencia: týždenne, každé dva týždne alebo mesačne.'
      ],
      bullets: [
        'Podlahy povysávané a umyté',
        'Utretie prachu z dostupných povrchov',
        'Sanitácia kúpeľne a kuchyne',
        'Vynesenie košov a výmena vriec'
      ],
      priceNote: '18 € / hod • Minimum 2 hodiny'
    },
    {
      slug: 'general-cleaning',
      title: 'Generálne upratovanie',
      short: 'Vyváženie medzi pravidelným a hĺbkovým čistením.',
      intro: 'Detailnejšie upratovanie, ktoré ide ďalej než bežná údržba.',
      description: [
        'Obsahuje všetky kroky pravidelného upratovania plus dôkladnú starostlivosť o kuchyňu a kúpeľňu, čistenie vonkajších plôch spotrebičov, vnútro rúry a chladničky a starostlivosť o miesta pre zvieratá.',
        'Odporúčaná frekvencia: týždenne, každé dva týždne alebo raz mesačne.'
      ],
      bullets: [
        'Zahŕňa checklist pravidelného upratovania',
        'Detailné čistenie kuchyne a kúpeľne',
        'Čistenie vnútra rúry a chladničky',
        'Odstránenie zvieracích chlpov a čistenie miest pre zvieratá (miesto na kŕmenie, toaleta)'
      ],
      priceNote: '20 € / hod • Minimum 2 hodiny'
    },
    {
      slug: 'deep-cleaning',
      title: 'Hĺbkové upratovanie',
      short: 'Kompletné čistenie zhora nadol pre maximálnu sviežosť.',
      intro: 'Najdetailnejšia služba zameraná na ťažko dostupné miesta a spotrebiče.',
      description: [
        'Zahŕňa každý krok generálneho upratovania, plus čistenie okien zvnútra aj zvonka (dostupné miesta), vnútro skríň a skriniek a hĺbkové čistenie spotrebičov ako chladnička, rúra či mikrovlnka.',
        'Na požiadanie aj čistenie balkóna. Odporúčané, keď chcete priestor dokonale oživiť.'
      ],
      bullets: [
        'Odstránenie vodného kameňa a mastnoty',
        'Vnútorné čistenie skríň a šatníkov',
        'Okná zvnútra aj zvonka (dostupné)',
        'Hĺbkové čistenie spotrebičov'
      ],
      priceNote: '22 € / hod • Minimum 2 hodiny'
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Upratovanie po stavebných prácach',
      short: 'Odstránenie prachu, farby a zvyškov po rekonštrukcii.',
      intro: 'Profesionálne čistenie po rekonštrukcii alebo výstavbe.',
      description: [
        'Odstránime prach, lepidlo, farbu a sutiny, vyčistíme okná, podlahy, povrchy a kúpeľne, aby bol priestor pripravený na nasťahovanie — čistý, svieži a bez prachu.'
      ],
      bullets: [
        'Odstránenie stavebného prachu a zvyškov',
        'Detailné čistenie zásuviek, vypínačov a líšt',
        'Čistenie okien, rámov a parapetov',
        'Finálne doleštenie podláh a povrchov'
      ],
      priceNote: 'Individuálna cena po obhliadke'
    },
    {
      slug: 'move-in-move-out',
      title: 'Sťahovacie upratovanie',
      short: 'Ideálne pri novom začiatku alebo odovzdávke bytu.',
      intro: 'Detailné upratovanie, aby ste mohli odovzdať alebo prevziať dokonale čistý domov.',
      description: [
        'Zameriavame sa na skrinky, spotrebiče, soklové lišty a príslušenstvo, aby bol priestor bezchybný pre prenajímateľa či nového majiteľa.',
        'Perfektné pred fotením, inšpekciou alebo pred nasťahovaním.'
      ],
      bullets: [
        'Vnútro skriniek a zásuviek vyčistené',
        'Odmastené spotrebiče zvnútra',
        'Utrené okná a rámy',
        'Dôraz na detaily ako lišty a vypínače'
      ],
      priceNote: 'Fixná cenová ponuka po rýchlej obhliadke'
    },
    {
      slug: 'office-cleaning',
      title: 'Kancelárske upratovanie',
      short: 'Udržujte pracovisko bezchybné a produktívne.',
      intro: 'Bezchybne upratané pracovisko vďaka profesionálnej službe.',
      description: [
        'Zabezpečíme dôkladné čistenie všetkých zón — od pracovísk a rokovacích miestností po kuchynky a sociálne zariadenia — aby bol priestor hygienický a reprezentatívny.',
        'Skúsený tím pracuje precízne a diskrétne, pomáha udržať profesionálny obraz a príjemné prostredie pre zamestnancov aj klientov.'
      ],
      bullets: [
        'Pracoviská, meetingy a recepcie',
        'Sanitované kuchynky a toalety',
        'Vynesené koše a triedený odpad',
        'Flexibilné harmonogramy mimo prevádzky'
      ],
      priceNote: 'Cena na požiadanie'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Komerčné upratovanie',
      short: 'Profesionálna služba pre reštaurácie, hotely a obchody.',
      intro: 'Vytvorte bezchybný a prívetivý priestor pre zákazníkov aj tím.',
      description: [
        'Dodávame špičkové upratovanie pre reštaurácie, hotely, obchody, salóny, fitness centrá a kancelárie, aby každý priestor pôsobil čisto a hygienicky.',
        'Zameriavame sa na detaily — od lesklých podláh a nábytku po dezinfikované kuchyne a toalety. Používame šetrné prostriedky a spoľahlivé metódy pre bezpečnosť a komfort.',
        'Ponúkame flexibilné harmonogramy a personalizované plány podľa vašej prevádzky, aby sme minimalizovali prerušenia.'
      ],
      bullets: [
        'Prevádzka, zázemie aj sklady',
        'Dezinfekcia často dotýkaných miest',
        'Starostlivosť o tvrdé podlahy aj koberce',
        'Plány na mieru pre každý typ biznisu'
      ],
      priceNote: 'Cena na požiadanie'
    },
    {
      slug: 'window-cleaning',
      title: 'Umývanie okien',
      short: 'Krištáľovo čisté okná zvnútra aj zvonka.',
      intro: 'Priezračné okná rozžiaria každý priestor.',
      description: [
        'Poskytujeme profesionálne čistenie okien v bytoch, kanceláriách aj komerčných priestoroch — zvnútra aj zvonka (len dostupné miesta).',
        'Používame ekologické, bezšmuhové prostriedky, sklá zostanú čisté a rámy lesklé. Pravidelné umývanie zlepšuje svetlo, čerstvosť a profesionálny vzhľad.'
      ],
      bullets: [
        'Vnútorné a dostupné vonkajšie sklá',
        'Utrenie rámov, parapetov a koľajničiek',
        'Bezšmuhové a ekologické prípravky',
        'Ideálne pre domy, kancelárie aj prevádzky'
      ],
      priceNote: '25 € / hod • Minimum 2 hodiny'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Čistenie kobercov a čalúnenia',
      short: 'Hĺbkové čistenie kobercov a čalúneného nábytku.',
      intro: 'Obnovíme mäkkosť a odstránime pachy z kobercov, sedačiek a stoličiek.',
      description: [
        'Odstraňujeme škvrny, alergény a usadeniny profesionálnou technikou prispôsobenou typu látky, textílie zostanú svieže.',
        'Ideálne ako doplnok k hĺbkovému upratovaniu alebo samostatné osvieženie frekventovaných priestorov.'
      ],
      bullets: [
        'Mokré extrakčné alebo nízkovlhké metódy',
        'Cielené odstránenie škvŕn a pachov',
        'Šetrné riešenia pre citlivé látky',
        'Rýchle schnutie pre minimálne prestoje'
      ],
      priceNote: 'Cena podľa typu materiálu a plochy'
    }
  ]
};

export default sk;
